import React, { useContext } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import { UppAuthContext } from "@app/provider";
import { routes } from "@app/routing";
import { ButtonNoShadow } from "@app/components/buttonNoShadow";
import { UPSSuccessInfoBox } from "@app/ups/components";

import "./upsPaymentConfirmation.scss";

const messages = defineMessages({
  upsPaymentConfirmationTitle: {
    id: "upsPaymentConfirmationTitle",
    defaultMessage: "Success!",
  },
  upsPaymentConfirmationDescription1: {
    id: "upsPaymentConfirmationDescription1",
    defaultMessage: "Thank you for updating your payment method.",
  },
  upsPaymentConfirmationDescription2: {
    id: "upsPaymentConfirmationDescription2",
    defaultMessage: "Future transactions will be processed accordingly.",
  },
  upsPaymentConfirmationButton: {
    id: "upsPaymentConfirmationButton",
    defaultMessage: "Go to Billing Center",
  },
});

const UPSPaymentConfirmation: React.FC = () => {
  const intl = useIntl();
  const { profile: uppProfile } = useContext(UppAuthContext);
  const navigate = useNavigate();

  return (
    <div className="ups-payment-conclusion">
      <div className="ups-payment-conclusion__content">
        <UPSSuccessInfoBox
          title={intl.formatMessage(messages.upsPaymentConfirmationTitle)}
          description1={intl.formatMessage(
            messages.upsPaymentConfirmationDescription1
          )}
          description2={intl.formatMessage(
            messages.upsPaymentConfirmationDescription2
          )}
        />
        {uppProfile?.patientUID && (
          <ButtonNoShadow raised onClick={() => navigate(routes.billingCenter)}>
            {intl.formatMessage(messages.upsPaymentConfirmationButton)}
          </ButtonNoShadow>
        )}
      </div>
    </div>
  );
};

export default UPSPaymentConfirmation;
